import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ContentInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const updatedRequest = request.clone({
      setHeaders: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Accept-Language': 'es-MX',
      },
    });

    return next.handle(updatedRequest);
  }
}
